import React, { FormEvent, useState } from 'react';
import Modal from './Modal';
import { TransactionType } from '../types/transaction';
import Button from './Button';

interface NewTransferProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (data: TransactionType) => void;
  isLoading: boolean;
  point: string | undefined;
  member: string | undefined;
}

const NewTransfer: React.FC<NewTransferProps> = ({ open, setOpen, onSubmit, isLoading, point, member }) => {
  const [input, setInput] = useState({
    point: null,
    price: null,
  });

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.validity.valid) {
      setInput((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(input);
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      {({ cancelButtonRef }) => (
        <div className="ceas-max-w-md ceas-mx-auto sm:ceas-max-w-lg lg:ceas-mx-0">
          <h2 className="ceas-text-3xl ceas-font-extrabold ceas-tracking-tight sm:ceas-text-4xl">
            Transfer to {member}
          </h2>
          <p className="ceas-mt-2 ceas-text-gray-500">
            Enter the CEASH$
          </p>
          <dl className="ceas-grid ceas-grid-cols-2 ceas-gap-x-4 ceas-gap-y-8">
            <div className="ceas-pt-6">
              <dt className="ceas-text-base ceas-font-medium ceas-text-gray-500">Your CEASH$</dt>
              <dd className="ceas-text-2xl ceas-font-extrabold ceas-tracking-tight ceas-text-emerald-600">
                {point ?? 0}
              </dd>
            </div>
          </dl>
          <form
            className="ceas-mt-9 ceas-grid ceas-grid-cols-1 ceas-gap-y-6 sm:ceas-grid-cols-2 sm:ceas-gap-x-8"
            onSubmit={submit}
          >
            <div>
              <label
                htmlFor="point"
                className="ceas-block ceas-text-sm ceas-font-medium ceas-text-gray-700"
              >
                CEASH$ to transfer
              </label>
              <div className="ceas-mt-1">
                <input
                  type="text"
                  name="point"
                  placeholder="0"
                  className="ceas-block ceas-w-full ceas-shadow-sm sm:ceas-text-sm focus:ceas-ring-primary-500 focus:ceas-border-primary-500 ceas-border-gray-300 ceas-rounded-md"
                  pattern="[0-9]*"
                  value={input.point ? input.point : ''}
                  onChange={onChange}
                />
              </div>
            </div>
            <div className="ceas-text-right sm:ceas-col-span-2">
              <Button size="sm" disabled={isLoading} onClick={() => setOpen(false)} ref={cancelButtonRef} className="ceas-mr-1">Cancel</Button>
              <Button type="submit" theme="primary" size="sm" disabled={isLoading}>{isLoading ? 'Loading..' : 'Submit'}</Button>
            </div>
          </form>
        </div>
      )}
    </Modal>
  );
};

export default NewTransfer;
